import { SelectC } from 'components'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useLoadOrderSellers } from 'modules/orders/hooks'

export const SelectSeller = () => {
  const { setValue } = useFormContext()

  const { data: sellers, isLoading: sellersLoading } = useLoadOrderSellers({})

  useEffect(() => {
    if (sellers?.defaultValue) {
      setValue('seller', sellers.defaultValue)
    } else {
      setValue('seller', null)
    }
  }, [sellers, setValue])

  return (
    <SelectC
      name="seller"
      label="Vendedor"
      options={sellers?.data}
      getOptionLabel={(option: any) => option?.id + ' - ' + option?.name}
      loading={sellersLoading}
    />
  )
}
